import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'
import Checkbox from 'components/ReusableComponents/Checkbox'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import PlayIcon from 'components/ReusableComponents/Icons/Play'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import YouTubeDialog from 'components/ReusableComponents/YouTubeDialog'
import useCopyText from 'hooks/useCopyText'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'

import choiceadvantage from '../../img/pms/choice-advantage.png'
import skytouch from '../../img/pms/skytouch.png'
import webrezpro from '../../img/pms/webrezpro.png'
import styles from './Pms.module.scss'

const logos = {
  webrezpro,
  choiceadvantage,
  skytouch
}

const PmsCredentialForm = ({ pms, onSave }) => {
  const [username, setUsername] = useState()
  const [password, setPassword] = useState()
  const [propertyId, setPropertyId] = useState()

  const [gmCredentialCheck, setGmCredentialCheck] = useState(false)

  const [isVideoVisible, setIsVideoVisible] = useState(false)

  const copy = useCopyText()

  return (
    <div
      className={`${styles.card} ${pms === 'choiceadvantage' ? styles.choiceCard : ''}`}
    >
      <CustomHeader title="PMS Sync" width={720} />
      <div className={styles.cardDesc}>
        <div className={styles.logo}>
          {pms ? <img src={logos[pms]} alt={`${pms} logo`} /> : null}
        </div>
        {pms === 'choiceadvantage' && (
          <div className={styles.steps}>
            <button
              className={styles.videoButton}
              onClick={() => setIsVideoVisible(true)}
            >
              <PlayIcon /> Watch how to create a user for Directful
            </button>
            {isVideoVisible && (
              <YouTubeDialog
                videoId="DncaRER_n4w"
                onClose={() => setIsVideoVisible(false)}
              />
            )}
            <ol className={styles.stepsOl}>
              <li>
                Use your GM login and sign into{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://choicecentral.com"
                >
                  Choicecentral.com
                </a>
              </li>
              <li>Go to Quick Links / User Admin</li>
              <li>Click on Add user</li>
              <li>Add user with following information:</li>
              <div className={styles.liInfo}>
                <p>
                  <span className={styles.liInfoLabel}> First name:</span>{' '}
                  <strong>Sway</strong>
                  <button className={styles.copyButton} onClick={() => copy('Sway')}>
                    <CopyIcon />
                    Copy
                  </button>
                </p>
                <p>
                  <span className={styles.liInfoLabel}>Last name:</span>
                  <strong>Pay</strong>
                  <button className={styles.copyButton} onClick={() => copy('Pay')}>
                    <CopyIcon />
                    Copy
                  </button>
                </p>
                <p>
                  <span className={styles.liInfoLabel}>Password:</span>{' '}
                  <strong>Savibook@1</strong>
                  <button
                    className={styles.copyButton}
                    onClick={() => copy('Savibook@1')}
                  >
                    <CopyIcon />
                    Copy
                  </button>
                </p>
              </div>
              <li>
                Add following permissions: <br />
                <strong>Front Desk</strong>, <strong>Remote access</strong> and{' '}
                <strong>Security level 5</strong>
              </li>
            </ol>
          </div>
        )}
      </div>
      <div className={styles.cardForm}>
        <form
          onSubmit={e => {
            e.preventDefault()
            onSave(username, password, propertyId)
          }}
          className={styles.form}
        >
          {pms === 'webrezpro' ? (
            <TextInput
              label="Property ID"
              isRequired
              value={propertyId}
              onChange={e => setPropertyId(e.target.value)}
              autoComplete="off"
              className={styles.input}
            />
          ) : null}
          <TextInput
            label="Username"
            isRequired
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoComplete="off"
            className={styles.input}
          />
          <TextInput
            label="Password"
            isRequired
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="off"
            className={styles.input}
          />
          <label className={styles.checkboxLabel}>
            <Checkbox
              onChange={e => setGmCredentialCheck(e.target.checked)}
              checked={gmCredentialCheck}
            />
            <span className={styles.checkboxLabelText}>I didn't use GM credentials</span>
          </label>
          <PrimaryBigButton
            className={styles.primaryButton}
            disabled={!(username && password && gmCredentialCheck)}
          >
            Save PMS info
          </PrimaryBigButton>
          <NavLink to="/">
            <button className={styles.secondaryButton}>Skip for now</button>
          </NavLink>
        </form>
      </div>
    </div>
  )
}

export default PmsCredentialForm
